import { defineComponent as B, inject as n, createElementBlock as y, openBlock as r, mergeProps as _, unref as o, createVNode as i, createBlock as s, createCommentVNode as f, withCtx as t, renderSlot as m, createTextVNode as F, toDisplayString as k } from "vue";
import p from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Toolbar/toolbar.js";
import x from "../Button.vue2.js";
import { ToolbarNumberOfFiltersKey as T, ToolbarClearAllFiltersKey as $ } from "./Toolbar.vue2.js";
import d from "./ToolbarGroup.vue2.js";
import v from "./ToolbarItem.vue2.js";
import { useOUIAProps as E } from "../../helpers/ouia.js";
const g = /* @__PURE__ */ B({
  name: "PfToolbarExpandableContent",
  __name: "ToolbarExpandableContent",
  props: {
    expanded: { type: Boolean },
    showClearFiltersButton: { type: Boolean },
    clearFiltersButtonText: { default: "Clear all filters" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(u) {
    const a = u, c = E({ id: a.ouiaId, safe: a.ouiaSafe }), b = n(T), C = n($);
    return (e, l) => (r(), y("div", _(o(c), {
      class: [o(p).toolbarExpandableContent, { [o(p).modifiers.expanded]: e.expanded }]
    }), [
      i(d, null, {
        default: t(() => [
          m(e.$slots, "default")
        ]),
        _: 3
      }),
      o(b) ? (r(), s(d, { key: 0 }, {
        default: t(() => [
          m(e.$slots, "label-container"),
          e.showClearFiltersButton ? (r(), s(v, { key: 0 }, {
            default: t(() => [
              i(x, {
                variant: "link",
                inline: "",
                onClick: l[0] || (l[0] = (N) => o(C) ?? void 0)
              }, {
                default: t(() => [
                  F(k(e.clearFiltersButtonText), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : f("", !0)
        ]),
        _: 3
      })) : f("", !0)
    ], 16));
  }
});
export {
  g as default
};
